export default __webpack_public_path__ + "static/media/juego2_perder.7902b37b.png";